module.exports = __webpack_public_path__ + "img/logo-small.267d3bd4.png";